import { initAdobeDataLayerMMT } from '@mmt/event-logger';
import { XDMWrapper } from '@gt-common/event-logger-web';

const isTrackingEnabled = () => {
  if (typeof document === 'undefined') return true;
  
  const trackCookie = document.cookie.split('; ').find(row => row.startsWith('track='));
  return trackCookie ? trackCookie.split('=')[1] === 'true' : true;
};

const setTrackingCookie = (enabled = true) => {
  if (typeof document === 'undefined') return;
  
  document.cookie = `track=${enabled}; path=/; max-age=86400`;
};

export const AnalyticsSdk = XDMWrapper.initAndSetAnalyticsSdk({
  org: 'MMT'
});

if (typeof window !== 'undefined') {
  window.setTrackingCookie = setTrackingCookie;
  window.isTrackingEnabled = isTrackingEnabled;
  window.AnalyticsSdk = AnalyticsSdk;
}

export const initAdobeDataLayer = (isDev = false) => {
  const trackingEnabled = isTrackingEnabled();
  
  if (!trackingEnabled) {
    return;
  }
  
  try {
    const environment = isDev ? 'development' : 'production';
    const scriptHtml = initAdobeDataLayerMMT(environment);
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = scriptHtml;
    const scriptElement = tempDiv.querySelector('script');
    
    if (scriptElement && scriptElement.src) {
      const existingScript = document.querySelector(`script[src="${scriptElement.src}"]`);
      if (existingScript) {
        return;
      }
      
      const newScript = document.createElement('script');
      newScript.src = scriptElement.src;
      newScript.async = scriptElement.async || true;
      
      newScript.onload = () => {
      };
      
      newScript.onerror = (error) => {
      };
      
      document.head.appendChild(newScript);
    }
  } catch (error) {
    console.error('Error initializing Adobe Data Layer:', error);
  }
};

export { isTrackingEnabled, setTrackingCookie };
